module.exports = __webpack_public_path__ + "src/assets/img/scroll-bg2.d2acc855.png";